<div *ngIf="$grupoCapas && $grupoCapas.length > 0" class="generated-layers-container">
    <div class="tool-title">
        <mat-icon (click)="toggleGeneratedLayers()" class="expand-icon" [ngClass]="{'expanded': this.generatedLayerService.isGeneratedLayersExpanded}">expand_more</mat-icon>
        <h2>Capas Generadas</h2>
    </div>

    <div [@ExpandCollapseGenerated]="this.generatedLayerService.isGeneratedLayersExpanded ? 'expanded' : 'collapsed'" (@ExpandCollapseGenerated.start)="onExpandCollapseStart($event)" (@ExpandCollapseGenerated.done)="onExpandCollapseDone($event)">
        <ng-container *ngFor="let grupo of $grupoCapas">
            <div class="tool-subtitle">
                <mat-icon style="margin-left: 10px;" (click)="toggleGeneratedGroupLayers(grupo)" class="expand-icon" [ngClass]="{'expanded': grupo.isGeneratedLayerGroupExpanded}">arrow_drop_down</mat-icon>
                <div >{{ grupo.name }}</div>
            </div>

            <div [@ExpandCollapseGenerated]="grupo.isGeneratedLayerGroupExpanded ? 'expanded' : 'collapsed'" (@ExpandCollapseGenerated.start)="onExpandCollapseStart($event)" (@ExpandCollapseGenerated.done)="onExpandCollapseDone($event)">
                <div *ngFor="let capa of grupo.layerList" style="margin-left: 25px;">
                    <div class="switch-item">
                        <label class="switch col-3">
                            <img *ngIf="capa.checked" [src]="'btn_on.svg' | findUrl" class="img-button" [id]="capa.name"
                                (click)="onToggleLayer(grupo, capa)">
                            <img *ngIf="!capa.checked" [src]="'btn_off.svg' | findUrl" class="img-button" [id]="capa.name"
                                (click)="onToggleLayer(grupo, capa)">
                        </label>
                        <span class="col-6">
                            <!-- <img [src]="capa.icon | findUrl" class="img-layer"> -->
                            {{ capa.name }}
                        </span>
                        <div class="switch-loading col-3">
                            <loading [isLoading]="capa.isLoading" [isAbsolute]="false"></loading>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
    
</div>